import lodash from 'lodash'
import Base, { criteriaIgnore } from "../base.store";
import request from "../../../../utils/request";

const baseUrl = '/api/v1/transaction/hazes'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        reportData(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/data`, data, { ...config, responseType: "blob" });
        },
        delHazsExpire(context, { data, config }) {
            return base.request.post(`${baseUrl}/hazes-del/exp`, data, { ...config });
        },
        searchShortDetail(context, { criteria, config }) {
            criteria = lodash.cloneDeepWith(criteria, (value, key) => {
                if (criteriaIgnore.includes(key)) {
                    return null;
                }
            });
            return request.post(`${baseUrl}/search/short-details`, criteria, { ...config });
        },
    },
    mutations: {
        ...base.mutations
    },
}
